import * as React from "react";

function About() {
  return (
    <div dir="rtl" style={{ textAlign: "center" }}>
      <p>
        לתמיכה ניתן לפנות למייל: <a href="mailto:tt.magbit@gmail.com">tt.magbit@gmail.com</a>
      </p>
      <p>
        רצוי להעלות תמונה של לוגו הת"ת לרזולוציה טובה יותר
      </p>
      <p>
        לע"נ יוסף אליהו בן אהרן ז"ל
      </p>
      <p>
        לע"נ יצחק בן יהושע ז"ל
      </p>
    </div>
  );
}

export default About;
